import { store } from '@/common/root';

const fetchNodeName = async (nodeId: string): Promise<string> => {
  try {
    const node = await store.$takeFirst('nodes/GET_OR_LOAD', { id: nodeId });
    return node?.name || '';
  } catch (error) {
    console.error(`Failed to fetch node with ID ${nodeId}:`, error);
    return '';
  }
};

export default fetchNodeName;
